/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLocalization } from '../../models/app-localization';

export interface AppLocalizationsControllerFindOne$Params {

/**
 * The app localization id
 */
  id: string;
}

export function appLocalizationsControllerFindOne(http: HttpClient, rootUrl: string, params: AppLocalizationsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<AppLocalization>> {
  const rb = new RequestBuilder(rootUrl, appLocalizationsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppLocalization>;
    })
  );
}

appLocalizationsControllerFindOne.PATH = '/localizations/{id}';
